import { scrollIntoView } from "../scrollIntoView";
import { getFocusableElements } from "./getFocusableElements";
/**
 * A function that is used to focus an element within the provided node.  This
 * can either focus the first, last, or a querySelector found element.
 *
 * @param container - Either an HTMLElement or the document to focus an element
 * within.
 * @param focus - Either the "first" or "last" string to focus the first or last
 * focusable element within the container or a query selector string to find a
 * focusable element within the container.
 * @param preventScroll - Boolean if the focus event should not scroll the
 * element into view. This should normally remain `false`, but can be useful if
 * the element gets focused while offscreen during a transition.
 * @param progamatic - Boolean if programatically focusable elements should be
 * included as well.
 */
export function focusElementWithin(container, focus, programatic, preventScroll, elements) {
    if (programatic === void 0) { programatic = false; }
    if (preventScroll === void 0) { preventScroll = false; }
    if (!elements || !elements.length) {
        elements = getFocusableElements(container, programatic);
    }
    var el;
    switch (focus) {
        case "first":
            el = elements[0];
            break;
        case "last":
            el = elements[elements.length - 1];
            break;
        default:
            el = container.querySelector(focus);
    }
    if (!el) {
        throw new Error("Unable to find a focusable element");
    }
    el.focus({ preventScroll: preventScroll });
    if (!preventScroll && container !== document) {
        scrollIntoView(container, el);
    }
}
//# sourceMappingURL=focusElementWithin.js.map